import { Box, Stack } from "@mui/material";
import React, { FunctionComponent } from "react";

import { FileViewerActions, ViewerNavigationControls } from "./components";
import type { FileViewerFooterProps } from "./types";

export const FileViewerFooter: FunctionComponent<FileViewerFooterProps> = ({
  fileName,
  setScale,
  downloadUrl,
  actionsDisabled,
  showNavigationControls = false,
  navigationContext,
  activeTab,
  onNavigate,
  isFileUploaded,
  successMessage,
  deleteTarget,
  deleteTitle,
}) => (
  <Box
    sx={(theme) => ({
      background: theme.palette.primary.main,
      padding: "12px 24px",
      color: "#ffffff",
    })}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <FileViewerActions
        actionsDisabled={actionsDisabled}
        downloadUrl={downloadUrl}
        fileName={fileName}
        setScale={setScale}
        isFileUploaded={isFileUploaded}
        successMessage={successMessage}
        deleteTarget={deleteTarget}
        deleteTitle={deleteTitle}
      />
      {showNavigationControls && navigationContext && (
        <ViewerNavigationControls
          fileName={fileName}
          navigationContext={navigationContext}
          activeTab={activeTab}
          onNavigate={onNavigate}
        />
      )}
    </Stack>
  </Box>
);
